// extracted by mini-css-extract-plugin
export default {"card":"InfoBlock_card__iWbce","collapseHeader":"InfoBlock_collapseHeader__nFaOr","collapse":"InfoBlock_collapse__IFdKd","headerTitle":"InfoBlock_headerTitle__2NnGp"};